var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.5L11 3.3V11.2H3V4.5Z",
    fill: "#4CC2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 3L21 1.9V11.2H13V3Z",
    fill: "#2A92FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.8H11V20.7L3 19.5V12.8Z",
    fill: "#2A92FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12.8H21V22.1L13 21V12.8Z",
    fill: "#1477E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindows);
export default __webpack_public_path__ + "static/media/windows.1d3dd96aaa264161855f711aa665903b.svg";
export { ForwardRef as ReactComponent };